export * from './skeleton.component';
export * from './skeleton.module';
